import React, { useEffect, useState } from 'react';
import {
  QrCode,
  Name,
  Container,
  Value,
  IconPix,
  IconContainer,
  Code,
} from './styles';
import QRCode from 'react-qr-code';
import Modal from '../index';
import Toast from '../../../components/Toast';
import { toast } from 'react-toastify';
import ClipLoader from 'react-spinners/ClipLoader';
import Button from '../../../components/Button';

import api from '../../../services/api';

interface IClose {
  handlerClose: () => void;
  data: any;
  dealId: number;
  portionId: number | null;
  databaseId: number;
}

function Pix({ handlerClose, data, dealId, portionId, databaseId }: IClose) {
  const [pixData, setPixData] = useState<GQL.IGetPixDataPublicResponse>();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function fetchData() {
      try {
        const res = await api.getPixData({
          options: { dealId, portionId: portionId ?? 0 },
          databaseId: Number(databaseId),
        });
        setPixData(res);
      } catch (error) {
        console.error(`Erro ao buscar dados Pix: ${error}`);
      } finally {
        setLoading(false);
      }
    }
    fetchData();
  }, [databaseId, dealId, portionId]);

  const copyToClipboard = (text: string) => {
    const input = document.createElement('input');
    document.body.appendChild(input);
    input.value = text;
    input.select();
    document.execCommand('copy');
    document.body.removeChild(input);
    toast.error(
      <Toast
        title={'Aviso'}
        type={'success'}
        description={'Copiado para Área de Transferência'}
      />
    );
  };
  return (
    <Modal
      title={'Pagar com o PIX'}
      billetWarning={true}
      handlerClose={handlerClose}
      icon={<IconPix />}
    >
      {loading ? (
        <IconContainer>
          <ClipLoader color='#222' loading={loading} size={50} />
        </IconContainer>
      ) : (
        <Container>
          <QrCode>
            <div className='description'>
              Para efetuar o pagamento, escaneie o Código QR abaixo ou clique no
              botão para copia-lo.
            </div>
            <QRCode
              size={150}
              value={pixData?.linhaDigitavel?.toString() ?? ''}
            />
          </QrCode>
          <Name> {data.creditorName}</Name>
          <Value>{pixData?.valorPagoFormatado} </Value>{' '}
          <Container>
            <Code
              onClick={() =>
                copyToClipboard(pixData?.linhaDigitavel?.toString() ?? '')
              }
            >
              {pixData?.linhaDigitavel}
            </Code>
            <Button
              color={'primary'}
              borderRadios='4'
              onClick={() =>
                copyToClipboard(pixData?.linhaDigitavel?.toString() ?? '')
              }
              paddingVertical={1}
            >
              Pix Copia e Cola
            </Button>
          </Container>
        </Container>
      )}
    </Modal>
  );
}

export default Pix;
